export default __webpack_public_path__ + "static/media/cap2.3b8ae22e.png";